/* ==========================================================================
   MAĞAZADA BUL / STORE FINDER  —  assets/store-finder.js
   Vanilla JS, bağımsız (jQuery vb. gerektirmez). Tema-bağımsız.
   ========================================================================== */
(function () {
  'use strict';

  function initAll() {
    document.querySelectorAll('[data-store-finder]').forEach(function (root) {
      if (root.__sfInit) return;
      root.__sfInit = true;
      new StoreFinder(root);
    });
  }

  function StoreFinder(root) {
    this.root = root;
    this.endpoint = root.dataset.endpoint || '';
    this.mock = root.dataset.mock === 'true';
    this.lowThreshold = parseInt(root.dataset.lowThreshold, 10) || 3;
    this.storesUrl = root.dataset.storesUrl || '';

    // DOM
    this.overlay      = root.querySelector('[data-sf-overlay]');
    this.dialog       = root.querySelector('.store-finder__dialog');
    this.citySel      = root.querySelector('[data-sf-city]');
    this.districtSel  = root.querySelector('[data-sf-district]');
    this.list         = root.querySelector('[data-sf-list]');
    this.emptyEl      = root.querySelector('[data-sf-empty]');
    this.loadingEl    = root.querySelector('[data-sf-loading]');
    this.errorEl      = root.querySelector('[data-sf-error]');
    this.noticeEl     = root.querySelector('[data-sf-notice]');
    this.variantRow   = root.querySelector('[data-sf-variant-row]');
    this.variantTitle = root.querySelector('[data-sf-variant-title]');

    // Modal'ı <body>'nin doğrudan altına taşı (portal). Tetikleyici buton artık
    // variant-picker > fieldset > option-selector__header gibi derin bir DOM
    // ağacının içinde; o ağaçtaki herhangi bir üst eleman transform/overflow:
    // hidden/contain kullanıyorsa position:fixed olan overlay tüm ekrana değil
    // o üst elemana göre konumlanır ("kesik" görünen buydu). Overlay'i body'ye
    // taşımak bunu kalıcı olarak çözer, tetikleyici buton yerinde kalır.
    if (this.overlay && this.overlay.parentNode !== document.body) {
      document.body.appendChild(this.overlay);
    }

    // Data
    this.variants = this._readJSON('[data-sf-variants]') || { variants: [] };
    this.variantById = {};
    (this.variants.variants || []).forEach(function (v) { this.variantById[v.id] = v; }, this);
    this.stores = this._readJSON('[data-sf-stores]') || [];

    this._stockCache = {};   // { variantId: { storeCode: qty } }
    this._lastRender = null; // yeniden çizim için

    this._bind();
    this._loadStoresFallback(); // metaobject boşsa JSON asset'ten çek
  }

  StoreFinder.prototype._readJSON = function (sel) {
    var el = this.root.querySelector(sel);
    if (!el) return null;
    try { return JSON.parse(el.textContent.trim()); } catch (e) { return null; }
  };

  /* ---- Mağaza rehberi metaobject'ten boş gelirse JSON asset fallback ---- */
  StoreFinder.prototype._loadStoresFallback = function () {
    if (this.stores && this.stores.length) { this._buildCityOptions(); return; }
    if (!this.storesUrl) { this._buildCityOptions(); return; }
    var self = this;
    fetch(this.storesUrl, { credentials: 'omit' })
      .then(function (r) { return r.ok ? r.json() : []; })
      .then(function (data) { self.stores = Array.isArray(data) ? data : []; })
      .catch(function () { self.stores = []; })
      .then(function () { self._buildCityOptions(); });
  };

  StoreFinder.prototype._bind = function () {
    var self = this;

    this.root.querySelectorAll('[data-sf-open]').forEach(function (btn) {
      btn.addEventListener('click', function () { self.open(); });
    });
    this.overlay.querySelectorAll('[data-sf-close]').forEach(function (btn) {
      btn.addEventListener('click', function () { self.close(); });
    });
    this.overlay.addEventListener('click', function (e) {
      if (e.target === self.overlay) self.close();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !self.overlay.hidden) self.close();
    });

    this.citySel.addEventListener('change', function () {
      self._buildDistrictOptions();
      self.render();
    });
    this.districtSel.addEventListener('change', function () { self.render(); });

    // Tema varyant değişimini yakala (form üzerindeki [name="id"])
    var form = this._productForm();
    if (form) {
      form.addEventListener('change', function () { self._onVariantChange(); });
    }
  };

  /* ---- Seçili varyantı temadan oku ---- */
  StoreFinder.prototype._productForm = function () {
    return document.querySelector('form[action*="/cart/add"], product-form form, form[data-type="add-to-cart-form"]');
  };
  StoreFinder.prototype._selectedVariantId = function () {
    var input = document.querySelector('form[action*="/cart/add"] [name="id"], product-form [name="id"], [name="id"]');
    return input ? String(input.value) : null;
  };
  StoreFinder.prototype._selectedVariant = function () {
    var id = this._selectedVariantId();
    return id ? this.variantById[id] : null;
  };

  StoreFinder.prototype._onVariantChange = function () {
    if (this.overlay.hidden) return;
    this._syncVariantUI();
    // Yeni varyant için stoğu tazele
    this.render(true);
  };

  StoreFinder.prototype._syncVariantUI = function () {
    var v = this._selectedVariant();
    if (v) {
      this.noticeEl.hidden = true;
      this.variantRow.hidden = false;
      this.variantTitle.textContent = v.title || '—';
    } else {
      this.noticeEl.hidden = false;
      this.variantRow.hidden = true;
    }
  };

  /* ---- Aç/Kapat ---- */
  StoreFinder.prototype.open = function () {
    this.overlay.hidden = false;
    document.documentElement.classList.add('sf-lock');
    this._syncVariantUI();
    var self = this;
    requestAnimationFrame(function () {
      self.overlay.classList.add('is-open');
      self.dialog.focus();
    });
    if (this.citySel.value) this.render(true);
  };
  StoreFinder.prototype.close = function () {
    var self = this;
    this.overlay.classList.remove('is-open');
    document.documentElement.classList.remove('sf-lock');
    setTimeout(function () { self.overlay.hidden = true; }, 220);
  };

  /* ---- Şehir / ilçe seçenekleri ---- */
  StoreFinder.prototype._buildCityOptions = function () {
    var cities = {};
    this.stores.forEach(function (s) { if (s.city) cities[s.city] = true; });
    var sorted = Object.keys(cities).sort(function (a, b) { return a.localeCompare(b, 'tr'); });
    var html = '<option value="">Şehir seçin</option>';
    sorted.forEach(function (c) { html += '<option value="' + esc(c) + '">' + esc(c) + '</option>'; });
    this.citySel.innerHTML = html;
  };
  StoreFinder.prototype._buildDistrictOptions = function () {
    var city = this.citySel.value;
    var set = {};
    this.stores.forEach(function (s) { if (s.city === city && s.district) set[s.district] = true; });
    var sorted = Object.keys(set).sort(function (a, b) { return a.localeCompare(b, 'tr'); });
    var html = '<option value="">Tümü</option>';
    sorted.forEach(function (d) { html += '<option value="' + esc(d) + '">' + esc(d) + '</option>'; });
    this.districtSel.innerHTML = html;
    this.districtSel.disabled = sorted.length === 0;
  };

  /* ---- Ana render ---- */
  StoreFinder.prototype.render = function (forceStock) {
    var v = this._selectedVariant();
    var city = this.citySel.value;

    // Varyant yoksa uyar
    if (!v) { this._syncVariantUI(); }

    // Şehir seçili değilse boş durum
    if (!city) {
      this._setStates({ empty: 'Mağazaları görmek için şehir seçin.' });
      this.list.innerHTML = '';
      return;
    }

    var district = this.districtSel.value;
    var filtered = this.stores.filter(function (s) {
      return s.city === city && (!district || s.district === district);
    });

    if (!filtered.length) {
      this._setStates({ empty: 'Bu bölgede mağaza bulunamadı.' });
      this.list.innerHTML = '';
      return;
    }

    // Varyant yoksa stok çekmeden sadece mağazaları listele
    if (!v) {
      this._renderList(filtered, null);
      this._setStates({});
      return;
    }

    var self = this;
    var cached = this._stockCache[v.id];
    if (cached && !forceStock) {
      this._renderList(filtered, cached);
      this._setStates({});
      return;
    }

    this._setStates({ loading: true });
    this._fetchStock(v).then(function (stockMap) {
      self._stockCache[v.id] = stockMap;
      self._renderList(filtered, stockMap);
      self._setStates({});
    }).catch(function () {
      self._renderList(filtered, null);  // stok yoksa yine listele, rozet gösterme
      self._setStates({ error: true });
    });
  };

  StoreFinder.prototype._setStates = function (opts) {
    this.emptyEl.hidden   = !opts.empty;
    if (opts.empty) this.emptyEl.textContent = opts.empty;
    this.loadingEl.hidden = !opts.loading;
    this.errorEl.hidden   = !opts.error;
  };

  /* ---- Liste çizimi ---- */
  StoreFinder.prototype._renderList = function (stores, stockMap) {
    var self = this;
    this.list.innerHTML = stores.map(function (s) {
      var badge = '';
      if (stockMap) {
        var qty = stockMap[s.code];
        badge = self._badge(typeof qty === 'number' ? qty : 0);
      }
      var maps = s.maps || ('https://www.google.com/maps/search/?api=1&query=' +
                 encodeURIComponent((s.name || '') + ' ' + (s.address || '')));
      var phone = (s.phone || '').replace(/\s+/g, '');
      return '' +
        '<li class="store-finder__item">' +
          '<div class="store-finder__item-main">' +
            '<h3 class="store-finder__store-name">' + esc(s.name || '') + '</h3>' +
            (s.district ? '<span class="store-finder__store-dist">' + esc(s.district) + '</span>' : '') +
            (s.address ? '<p class="store-finder__store-addr">' + esc(s.address) + '</p>' : '') +
            '<div class="store-finder__actions">' +
              (phone ? '<a class="store-finder__act" href="tel:' + esc(phone) + '">Ara</a>' : '') +
              '<a class="store-finder__act" href="' + esc(maps) + '" target="_blank" rel="noopener">Yol Tarifi</a>' +
            '</div>' +
          '</div>' +
          (badge ? '<div class="store-finder__item-stock">' + badge + '</div>' : '') +
        '</li>';
    }).join('');
  };

  StoreFinder.prototype._badge = function (qty) {
    var cls, label;
    if (qty <= 0) { cls = 'is-out';  label = 'Stokta yok'; }
    else if (qty <= this.lowThreshold) { cls = 'is-low'; label = 'Son ürünler'; }
    else { cls = 'is-in'; label = 'Stokta var'; }
    return '<span class="store-finder__badge ' + cls + '">' +
             '<span class="store-finder__dot"></span>' + label +
           '</span>';
  };

  /* ---- Stok kaynağı ---- */
  StoreFinder.prototype._fetchStock = function (variant) {
    if (this.mock || !this.endpoint) {
      return Promise.resolve(this._mockStock(variant));
    }
    var params = new URLSearchParams({
      barcode: variant.barcode || '',
      sku: variant.sku || '',
      variant_id: String(variant.id)
    });
    return fetch(this.endpoint + '?' + params.toString(), {
      headers: { 'Accept': 'application/json' },
      credentials: 'same-origin'
    })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
      .then(function (data) {
        // Kontrat: { ok:true, stores: { "STORE_CODE": { qty:5 } | 5 } }
        var out = {};
        var src = (data && data.stores) || {};
        Object.keys(src).forEach(function (code) {
          var val = src[code];
          out[code] = (typeof val === 'number') ? val : (val && val.qty) || 0;
        });
        return out;
      });
  };

  // Deterministik sahte stok (varyant + mağaza koduna göre) — demo/test için
  StoreFinder.prototype._mockStock = function (variant) {
    var out = {};
    var seed = String(variant.id);
    this.stores.forEach(function (s) {
      var h = 0, str = seed + '|' + s.code;
      for (var i = 0; i < str.length; i++) { h = (h * 31 + str.charCodeAt(i)) & 0xffff; }
      out[s.code] = h % 8; // 0..7
    });
    return out;
  };

  function esc(str) {
    return String(str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  // Shopify section reload (tema editörü) desteği
  document.addEventListener('shopify:section:load', initAll);

  // Widget artık variant-picker İÇİNDE (Beden etiketinin yanında) gömülü.
  // Tema, kombine ürün/varyant değişiminde bu alanı AJAX ile innerHTML
  // olarak değiştirebilir — yeni DOM parçası '__sfInit' bayrağı taşımaz.
  // MutationObserver ile böyle bir değişiklik olursa otomatik yeniden başlat.
  if ('MutationObserver' in window) {
    var sfObserver = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var node = added[j];
          if (node.nodeType !== 1) continue;
          if ((node.matches && node.matches('[data-store-finder]')) ||
              (node.querySelector && node.querySelector('[data-store-finder]'))) {
            initAll(document);
            return;
          }
        }
      }
    });
    sfObserver.observe(document.body, { childList: true, subtree: true });
  }
})();